
const flourDictionary = {
  'All Purpose': 'All Purpose',
  'AP': 'All Purpose',
  'Bread Flour': 'Bread Flour',
  'Bread': 'Bread Flour',
  'BF': 'Bread Flour',
  'Whole Wheat': 'Whole Wheat',
  'WW': 'Whole Wheat',
  'Wh Wheat': 'Whole Wheat',
}

export function getNormalizedFlourName(name) {
  const trimmedName = name.trim()
  if (flourDictionary[trimmedName]) {
    return flourDictionary[trimmedName]
  }
  return trimmedName
}

const inclusionDictionary = {
  'water'        : {name: 'Water'},
  'buttermilk'   : {name: 'Butter Milk'},
  'cream'        : {name: 'Heavy Cream'},
  'powderedmilk' : {name: 'Powdered Milk'},
  'wholemilk'    : {name: 'Whole Milk'},
  'skimmilk'     : {name: 'Skim Milk'},
  'tourage'      : {name: 'Tourage Butter'},
  'butter'       : {name: 'Butter', effLiquidPct: 0.15}, // euro-style butter @15%; american butter @ 20%
  'eggyolk'      : {name: 'Egg Yolks', effLiquidPct: 0.55},
  'eggwhite'     : {name: 'Egg Whites', effLiquidPct: 0.90},
  'egg'          : {name: 'Whole Eggs', effLiquidPct: 0.75},
  'sugar'        : {name: 'Sugar', effLiquidPct: 0.0},  // NOTE: solid sugar has an effect on dough slackness but not actual hydration contrib
  'honey'        : {name: 'Honey', effLiquidPct: 0.20},
  'barleysyrup'  : {name: 'Barley Syrup', effLiquidPct: 0.20},
  'molasses'     : {name: 'Molasses', effLiquidPct: 0.20},
  'chocolate'    : {name: 'Chocolate'}
}

export function getNormalizedInclusionName(name) {
  const trimmedName = name.trim()
  let condensedname = trimmedName.toLowerCase().replace(/[\s0-9]/g, '')

  // recognize various forms of eggs...
  if (condensedname.includes('egg') && condensedname.includes('yolk')) {
    condensedname = 'eggyolk'
  } else if (condensedname.includes('egg') && condensedname.includes('white')) {
    condensedname = 'eggwhite'
  }
  // recognize two forms/uses of butter: tourage => lamination and is not mixed into dough...
  if (condensedname.includes('butter') && (condensedname.includes('fold') || condensedname.includes('tourage'))) {
    condensedname = 'tourage'
  }
  // recognize powdered milk...
  if (condensedname.includes('milk') && condensedname.includes('powder')) {
    condensedname = 'powderedmilk'
  }
  // recognize barley syrup...
  if (condensedname.includes('barley') && condensedname.includes('syrup')) {
    condensedname = 'barleysyrup'
  }

  const key = Object.keys(inclusionDictionary).find(k => condensedname.includes(k))
  if (key) {
    return inclusionDictionary[key]['name']
  }
  return trimmedName.replace(/\d+/, '')
}

export function getEffectiveLiquidPct(inclusionName) {
  const val = Object.values(inclusionDictionary).find(v => v['name'] === inclusionName)
  if (!val) {
    return undefined
  }
  return Object.hasOwn(val, 'effLiquidPct') ? val['effLiquidPct'] : undefined
}

export function getInclusionsWithEffLiquidPct() {
  const contributingInclusions = []
  Object.values(inclusionDictionary).forEach((v) => {
    if (Object.hasOwn(v, 'effLiquidPct') && v['effLiquidPct'] > 0) {
      contributingInclusions.push(v)
    }
  })
  return contributingInclusions
}

export function getLiquidContributingInclusionWeight(inclusionSummaryItems) {
  let liquidContributingIngredientWeight = 0
  const inclusionsHavingEffLiquidPct = getInclusionsWithEffLiquidPct()
  if (inclusionsHavingEffLiquidPct?.length > 0) {
    for (const inclusionSummary of inclusionSummaryItems) {
      const inclusionName = inclusionSummary['name']
      const matchingInclusion = inclusionsHavingEffLiquidPct.find( i => i['name'] === inclusionName)
      if (matchingInclusion) {
        const contributingWeight = Math.round(inclusionSummary['weight'] * matchingInclusion['effLiquidPct'])
        liquidContributingIngredientWeight += contributingWeight
      }
    }
  }
  return liquidContributingIngredientWeight
}